<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Laboratoires" />
            <Laboratoire />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import Laboratoire from '../Laboratoire/Laboratoire.vue'


export default {
    name: 'LaboratoirePage',
    components: {
        NavBar,
        PageTitle,
        Laboratoire,
        FooterComp,
    }
}
</script>